module.exports = __webpack_public_path__ + "img/search.7f26a99a.svg";